import AOS from "aos";
import {addAnimationOnButtons, addDescritionExternalLink, addFocusOnButtons, formatAmountInDollar} from "./common/util";
import {initCybermetrie} from "./common/cybermetrie";

$(() => {

    /* Wrap all btn with a span for the animation */
    addAnimationOnButtons();
    addFocusOnButtons();
    addDescritionExternalLink()

    /* Closing header account dropdown button on an outside click*/
    $('.sub-navigation-button').on('click', function () {
        const container = $(this);
        $(document).on('mouseup', function (e) {
            if (!container.is(e.target as any) && container.has(e.target as any).length === 0) {
                container.removeClass('active');
                $('.sub-navigation-menu').css('display', 'none')
            }
        });
    });

    initCybermetrie();

    /* trigger filter action on enter */
    const $tabs = $('.tab-item');
    if ($tabs.length > 0) {
        $tabs.each(function () {
            const $tabDiv = $(this);
            let $tabA = $tabDiv.find('> a');
            let $item = $tabA.length > 0 ? $tabA : $tabDiv;
            $item.on('keyup', function (event) {
                if (event.key === 'Enter') {
                    $item.trigger('click');
                }
            }).on('keydown', function (event) {
                // This prevents the keydown to be called
                if (event.key === 'Enter') {
                    event?.preventDefault();
                }
            });
        })
    }

    $('.number-solde').each(function () {
        $(this).text(formatAmountInDollar(parseInt($(this).text())));
    })

});

$(window).on("load", function () {
    AOS.init({
        once: true,
        duration: 450,
        easing: 'ease'
    });
});

//Debug anchor For iPhone
document.addEventListener("DOMContentLoaded", () => {
    const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const hash = window.location.hash.slice(1);
    const element = document.getElementById(hash);

    if (isiOS && element) {
        element.scrollIntoView();
    }
});
